<gbc-modal class="validation-messages-modal" [title]="data?.title">
  <div class="container">
    <ul>
      @for (validationMessage of data.validationMessages; track validationMessage) {
        <li>
          <pre>{{ validationMessage }}</pre>
        </li>
      }
    </ul>
  </div>
</gbc-modal>
